import React, { useState, useEffect } from 'react';
import TreeviewRow from './treeviewRow.js';
import './css/TreeviewTable.css';
import { Turl } from './tUrl.js'
import { t } from 'ttag';

function TreeviewTable() {
    const [rootNodes, setRootNodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const tg = window.Telegram ? window.Telegram.WebApp : null;
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const _userData = tg ? tg.initData : null;
                let userData = { initData: _userData }
                const response = await fetch(Turl + '/api/afilateTree', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(userData),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setRootNodes(data.treeData);
                setLoading(false);
            } catch (e) {
                setError(e);
                setLoading(false);
                console.error("Error loading initial data:", e);
            }
        };

        fetchInitialData();
    }, []);

    if (loading) {
        return <div>{t`Load...`}</div>;
    }

    if (error) {
        return <div>{t`Error load:`} {error.message}</div>;
    }

    return (
        <div className="treeview-table">
            <table>
                <thead>
                    <tr>
                        <th>{t`Referal`}</th>
                    </tr>
                </thead>
                <tbody>
                    {rootNodes.map((item) => (
                        <TreeviewRow key={item.id} item={item} loadChildren={loadChildren} level={0} />
                    ))}
                </tbody>
            </table>
        </div>
    );

    async function loadChildren(itemId, level) {
        try {
            const response = await fetch(Turl + '/api/afilate/children', { // Потрібно створити цей ендпоінт на бекенді
                method: 'POST',
                headers: { 'Content-Type': 'application/json', },
                body: JSON.stringify({ parentId: itemId, level: level }),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // console.log(data);

            return data; // Очікується масив дочірніх елементів
        } catch (error) {
            console.error("Error loading child elements:", error);
            return null;
        }
    }
}

export default TreeviewTable;